import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCommentFilled16 = function SvgCommentFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.59 0 0 3.589 0 8c0 1.475.401 2.902 1.16 4.137L.018 15.561a.335.335 0 0 0 .408.426l3.622-1.034A7.968 7.968 0 0 0 8 16c4.411 0 8-3.589 8-8s-3.589-8-8-8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.571 5.714h6.857M4.571 8h6.857m-6.857 2.286h6.857",
    stroke: "#fff",
    strokeLinecap: "round"
  })));
};

var CommentFilled16Svg = SvgCommentFilled16;

export { CommentFilled16Svg as default };
//# sourceMappingURL=CommentFilled16.svg.js.map
